// Campaign configuration for Rhuna Portal
// This is a whitelabel solution with a single active campaign

export const CAMPAIGN_ID = 'rhuna-portal';
export const CAMPAIGN_GROUP_ID = '1';

// Other campaign-related constants
export const CAMPAIGN_CONFIG = {
  id: CAMPAIGN_ID,
  groupId: CAMPAIGN_GROUP_ID,
  name: 'Rhuna',
  description: 'Rhuna Quest Campaign',
  // Add more campaign-specific configuration as needed
} as const;
